module.exports = __webpack_public_path__ + "img/223.fa064afe.png";